import 'react';
import BaseComponent from './base-component';
import { getIntlMessage } from '../../services/settings/settings-store';
import IntlMessageFormat from 'intl-messageformat';
// tslint:disable:no-unsafe-any

/**
 * @todo remove after refactoring
 */
class InternationalizedComponent<PropsType, StateType> extends BaseComponent<PropsType, StateType> {
    constructor(props: PropsType, options: {}) {
        super(props, options);
    }

    public i18n(messageId: string): string {
        return getIntlMessage(messageId);
    }

    /**
     * @deprecated use i18n
     * @param messageId
     * @returns {any|string}
     */
    public getIntlMessage(messageId: string): string {
        return getIntlMessage(messageId);
    }

    public formatMessage<T extends {}>(message: string, values: T): string {
        let formatted = '';
        if (this.context && this.context.intl) {
            formatted = this.context.intl.formatString(message, values);
        } else {
            const res = new IntlMessageFormat(message, 'ru');
            formatted = res.format(values);
        }
        return formatted;
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default InternationalizedComponent;
